import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './validateVinsMutation.graphql';

export const useValidateVinsMutation = (
  opts?: MutationHookOptions<
    ValidateVinsMutation,
    ValidateVinsMutationVariables
  >,
) => {
  return useMutation<ValidateVinsMutation, ValidateVinsMutationVariables>(
    mutation,
    opts,
  );
};
